import React from 'react';
export function Footer() {
  return <footer className="bg-[#122618] text-[#cbd5e1] py-12 border-t border-[#2c4c3b]" data-id="element-104">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-105">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-106">
          🌾 MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360™
        </h4>

        <p className="text-[#cbd5e1] mb-6" data-id="element-107">
          Hecho por especialistas, para docentes de ciencias agropecuarias de
          toda Argentina.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-108">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-white transition-colors" data-id="element-109">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-110">·</span>
          <span className="hover:text-white transition-colors" data-id="element-111">
            📱 @centralpack.ar
          </span>
        </div>

        <div className="text-xs text-[#8b9fb0] border-t border-[#2c4c3b] pt-8 space-y-3" data-id="element-112">
          <p data-id="element-113">
            © 2026 MegaPack Educación Agropecuaria y Ganadera 360 — Todos los
            derechos reservados.
          </p>
          <p className="italic text-[#8b9fb0]/80" data-id="element-114">
            "El MegaPack Educación Agropecuaria y Ganadera 360 no te convierte
            en mejor docente. Vos ya sos un buen docente. Lo que hace el
            MegaPack es darte el tiempo y las herramientas para que eso se note
            en cada clase."
          </p>
        </div>
      </div>
    </footer>;
}